import { Clone } from "js-vextensions";
import { GenerateUUID } from "Utils/General/KeyGenerator";
import _ from "lodash";
import { AddUpgradeFunc } from "../../Admin";
import { ProcessDBData } from "mobx-firelink";
const newVersion = 7;
AddUpgradeFunc(newVersion, async (oldData, markProgress) => {
    const data = ProcessDBData(Clone(oldData), true);
    // clear outdated data
    // ==========
    data.general.data = {};
    const conversions = {
        attributes: [],
        books: [],
        characters: [],
        events: [],
        mapObjects: [],
        seeds: [],
    };
    function GetNewKey(collection, oldEntryKey) {
        const conversionEntry = conversions[collection].find(a => a.oldKey + "" == oldEntryKey + "");
        if (conversionEntry == null) {
            const placeholderKey = _.padEnd(oldEntryKey.toString().slice(0, 22), 22, "_MISSING");
            Log(`Found broken reference. CollectionKey:${collection} OldEntryKey:${oldEntryKey} PlaceholderKey:${placeholderKey}`);
            return placeholderKey;
        }
        return conversionEntry.newKey;
    }
    conversions.VKeys().forEach(collectionKey => {
        data[collectionKey].VValues().forEach(entry => conversions[collectionKey].push({ oldKey: entry._key, newKey: GenerateUUID() }));
    });
    // convert heirarchal keys (ie. the primary key for each object, as present in the path)
    // ==========
    function ReplacePairKey(pairsObj, oldKey, collectionReffedByKey) {
        const newKey = GetNewKey(collectionReffedByKey, oldKey);
        const value = pairsObj[oldKey];
        delete pairsObj[oldKey];
        pairsObj[newKey] = value;
    }
    function ReplacePairKeys(pairsObj, collectionReffedByKey) {
        (pairsObj || {}).Pairs().forEach(pair => ReplacePairKey(pairsObj, pair.key, collectionReffedByKey));
    }
    function ReplacePairValues(pairsObj, collectionReffedByValue) {
        (pairsObj || {}).Pairs().forEach(pair => pairsObj[pair.key] = GetNewKey(collectionReffedByValue, pair.value));
    }
    /* conversions.VKeys().forEach((collectionKey) => {
        ReplacePairKeys(data[collectionKey], collectionKey as any);
    }); */
    // convert referential keys (ie. the key for each object, that is used within the prop of another object to refer to it)
    // ==========
    ReplacePairKeys(data.attributes, "attributes");
    ReplacePairKeys(data.books, "books");
    data.books.VValues().forEach(entry => {
        entry.rootMapObject = GetNewKey("mapObjects", entry.rootMapObject);
    });
    ReplacePairKeys(data.characters, "characters");
    data.characters.VValues().forEach(entry => {
        ReplacePairKeys(entry.attributeLevels, "attributes");
        entry.book = GetNewKey("books", entry.book);
        ReplacePairValues(entry.eventIndexes, "events");
    });
    ReplacePairKeys(data.events, "events");
    data.events.VValues().forEach(entry => {
        delete entry["indexAccepted"];
        entry.book = GetNewKey("books", entry.book);
        ReplacePairKeys(entry.characters, "characters");
        if (entry.seed)
            entry.seed = GetNewKey("seeds", entry.seed);
        if (entry.steps)
            entry.steps.forEach(step => {
                ReplacePairKeys(step.actions, "characters");
            });
    });
    ReplacePairKeys(data.mapObjects, "mapObjects");
    data.mapObjects.VValues().forEach(entry => {
        ReplacePairKeys(entry.children, "mapObjects");
        if (entry.parent)
            entry.parent = GetNewKey("mapObjects", entry.parent);
    });
    ReplacePairKeys(data.seeds, "seeds");
    data.seeds.VValues().forEach(entry => {
        ReplacePairKeys(entry.attributeLevels, "attributes");
        entry.book = GetNewKey("books", entry.book);
    });
    return data;
});
